import * as React from "react";

import { cn } from "@/lib/utils";

import { Link } from "./link";
import type { LinkProps } from "./link";

const InlineLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, ...props }, ref) => (
    <Link
      ref={ref}
      className={cn(
        "text-pulse-700 hover:text-pulse-800 font-medium",
        "underline decoration-1 underline-offset-[3px] hover:decoration-[1.5px]",
        "transition-[text-decoration-thickness,color] duration-[120ms] ease-out",
        "focus-visible:outline-pulse-700 focus-visible:rounded-ds-xs focus-visible:outline-2 focus-visible:outline-offset-2",
        className
      )}
      {...props}
    />
  )
);
InlineLink.displayName = "InlineLink";

export { InlineLink };
